import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import type { Grain, Point } from "../salesSeries"
import { AXIS_TICK, PointTooltip, actionMarkers, xAxisProps } from "./chartParts"

export const SOLD = "var(--series-1)"
export const GIFTED = "var(--series-2)"

// The same period split into sold (bottom) and gifted (stacked on top), for
// when the room wants to see how much went out as gifts.
export default function SalesChart({ points, grain }: { points: Point[]; grain: Grain }) {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={points} margin={{ top: 24, right: grain === "month" ? 40 : 16, bottom: 0, left: 0 }} barCategoryGap={grain === "day" ? 1 : "20%"}>
        <CartesianGrid stroke="var(--chart-grid)" vertical={false} />
        <XAxis {...xAxisProps(points, grain)} />
        <YAxis width={44} tick={AXIS_TICK} stroke="var(--chart-grid)" />
        <Tooltip
          content={<PointTooltip lines={(p: Point) => [`Sold: ${p.sold.toLocaleString()}`, `Gifted: ${p.gifted.toLocaleString()}`]} />}
          cursor={{ fill: "var(--muted)" }}
        />
        <Bar dataKey="sold" stackId="out" fill={SOLD} stroke="var(--card)" strokeWidth={1} isAnimationActive={false} />
        <Bar dataKey="gifted" stackId="out" fill={GIFTED} stroke="var(--card)" strokeWidth={1} radius={[2, 2, 0, 0]} isAnimationActive={false} />
        {actionMarkers(points)}
      </BarChart>
    </ResponsiveContainer>
  )
}
